export var contentWrapper = 'flex flex-row items-center justify-between px-4 py-4 sm:px-6';
export var title = 'text-base leading-snug font-semibold text-textDark truncate';
export var description = 'font-normal text-textMid text-md';
export var titleChevron = 'h-5 w-5 text-textMid';
export var titlelistItemContainer = "block rounded-2xl";
//# sourceMappingURL=title-list-item.styles.js.map